import {searchByWorkstationIdApi} from "@/RoseRepo.js"

async function CreateModuleUrl(moduleName,workstationId)
{
    	const { moduleVersion } = await searchByWorkstationIdApi({moduleName, workstationId: workstationId || undefined})
    	const [labelName, username, ...rest] = moduleName.split('-');
    	const feature = rest.join('-')
    	const path = `${process.realm.REALM_APP_REMOTE}/${username}/${labelName}/${feature}.sys/${moduleVersion}/${moduleName}`
    	const jsUrl = `${path}.js`
    	const cssUrl = `${path}.css`
    	return { jsUrl, cssUrl }
}
function LoadModuleCss(moduleName,url,context)
{
    	const { requireWindow: { document: doc } } = context
    	if (!doc.querySelector(`#${moduleName}`))
    	{
    	    const link = doc.createElement('link')
    	    link.onerror = () => {}
    	    link.id = moduleName
    	    link.rel = 'stylesheet'
    	    link.href = url
    	    doc.head.appendChild(link)
    	}
}
async function LoadModuleByName(moduleName,workstationId,context)
{
    	const { jsUrl, cssUrl } = await CreateModuleUrl(moduleName,workstationId)
    	if (context && cssUrl)
    	{
    	    LoadModuleCss(moduleName,cssUrl,context)
    	    return context.importFn(jsUrl)
    	}
    	else
    	{
    	    return import(jsUrl)
    	}
}
	const windowMap = new WeakMap()
	export const loadModule = async (moduleName, workstationId, context) =>
	{
	    if (!moduleName)
	    {
	        console.error("moduleName can't empty")
	        return
	    }
	    const requireWindow = context ? context.requireWindow : window
	    if (!windowMap.has(requireWindow))
	    {
	        windowMap.set(requireWindow, {})
	    }
	    const moduleMap = windowMap.get(requireWindow)
	    let module = moduleMap[moduleName]
	    if (!module)
	    {
	        module = moduleMap[moduleName] = LoadModuleByName(moduleName,workstationId,context);
	    }
	    return module
	}

